import { AppFeatures } from "./AppFeatures";

export default AppFeatures;
